module.exports = __webpack_public_path__ + "static/media/BIM 360 Coordinate.2cd3d7df.png";